module.exports = "/static/assets/421e794b57e9d8a55f61dea8acbaf122.png";